import Command from './command';
import CommandResult from './command-result';
import Constants from '@intercom/embercom-composer/lib/constants';
export default Command.extend({
  processZeroWidth() {
    if (this.get('selection.isAtStartOfBlock')) {
      if (this.get('firstSelectedBlock.isMedia')) {
        return this._deleteMediaBlock();
      } else {
        return this._zeroWidthAtZero();
      }
    } else if (this.get('selection.isAtStartOfItem')) {
      return this._zeroWidthAtItemZero();
    } else {
      this.expandSelectionLeftBy(1);
      let result = this.applyActionToFirstSelectedBlock('delete');
      if (result.get('updatesCaret')) {
        this.setSelectionToPositionIndex(result.get('blockRange.startPoint.positionIndex'));
      }
      this.collapseSelection();
      return CommandResult.create({
        shouldRerender: true
      });
    }
  },
  processSingleBlock() {
    if (this.get('isFirstSelectedBlockCovered')) {
      this.removeFirstSelectedBlock();
      let insertPoint = this.get('selection.startBlockIndex');
      this.setSelectionToStartOf(this.insertDefaultBlock(insertPoint));
      return CommandResult.create({
        shouldRerender: true
      });
    }
    if (this.get('firstSelectedBlock.isListType')) {
      return this._singleListBlock();
    } else {
      let result = this.applyActionToFirstSelectedBlock('delete');
      if (result.get('updatesCaret')) {
        this.setSelectionToPositionIndex(result.get('blockRange.startPoint.positionIndex'));
      }
      this.collapseSelection();
    }
    return CommandResult.create({
      shouldRerender: true
    });
  },
  processMultiBlock() {
    this.removeBlocks(this.get('coveredBlocks'));
    if (this.get('allBlocksCovered')) {
      this.setSelectionToStartOf(this.insertDefaultBlock(this.get('selection.startBlockIndex')));
      return CommandResult.create();
    }
    if (this.get('firstAndLastAreLists')) {
      return this._joinLists();
    }
    if (this.get('firstSelectedBlockNotCoveredAndNotList')) {
      this.applyActionToFirstSelectedBlock('delete');
    }
    if (this.get('lastSelectedBlockNotCoveredAndNotList')) {
      this.applyActionToLastSelectedBlock('delete');
    }
    if (this.get('firstSelectBlockNotCoveredAndIsList')) {
      this._delegateToFirstSelectedBlock();
    }
    if (this.get('lastSelectBlockNotCoveredAndIsList')) {
      this._delegateToLastSelectedBlock();
    }
    if (this.get('isLastSelectedBlockNotCovered') && !this.get('isFirstSelectedBlockCovered')) {
      this.get('firstSelectedBlock').join(this.get('lastSelectedBlock'), {
        mergeItems: true
      });
      if (!this.get('lastSelectedBlock.isListType')) {
        this.removeBlock(this.get('lastSelectedBlock'));
      }
    }
    this.collapseSelection();
    return CommandResult.create({
      shouldRerender: true
    });
  },
  _zeroWidthAtZero() {
    if (this.get('config.singleBlock')) {
      return;
    }
    if (this.get('firstSelectedBlockAndPreviousAreLists')) {
      this.get('previousBlock').join(this.get('firstSelectedBlock'));
      this.setSelectionToStartOfItem(this.get('previousBlock'), this.get('firstSelectedBlock.blockList.firstObject'));
      this.removeFirstSelectedBlock();
      return CommandResult.create();
    }
    if (this.get('firstSelectedBlock.isListType') && (this.get('firstSelectedBlock.isEmpty') || this.get('firstSelectedBlock.blockList.length') === 1)) {
      return this._undoListReplacement();
    }
    if (this.get('previousBlock') && this.get('previousBlock.isMedia')) {
      if (this.get('firstSelectedBlock.isEmpty') || this.get('firstSelectedBlock.isMedia')) {
        this.removeFirstSelectedBlock();
      }
      this.setSelectionToEndOf(this.get('previousBlock'));
      return CommandResult.create({
        shouldRerender: true
      });
    }
    if (this.get('nextBlock.isMedia') && this.get('firstSelectedBlock.isEmpty')) {
      this.removeFirstSelectedBlock();
      if (this.get('previousBlock')) {
        this.setSelectionToEndOf(this.get('previousBlock'));
      } else {
        this.setSelectionToStartOf(this.get('nextBlock'));
      }
      return CommandResult.create({
        shouldRerender: true
      });
    }
    if (this.get('previousBlock') && this.get('previousBlock.isEmpty') && this.get('firstSelectedBlock.isHeadingType')) {
      this.removeBlock(this.get('previousBlock'));
      this.setSelectionToStartOf(this.get('firstSelectedBlock'));
      return CommandResult.create({
        shouldRerender: true
      });
    }
    if (this.get('previousBlock') && this.get('previousBlock.isHeadingType') && this.get('firstSelectedBlock.isListType')) {
      return this._zeroWidthAtItemZero();
    }
    if (this.get('previousBlock')) {
      return this._joinPreviousBlock();
    }
    if (this.get('firstSelectedBlock.isEmpty')) {
      this.removeFirstSelectedBlock();
      this.insertDefaultBlock(0);
      return CommandResult.create();
    }
    if (this.get('firstSelectedBlock.isListType')) {
      return this._zeroWidthAtItemZero();
    }
    return CommandResult.create({
      shouldRerender: true
    });
  },
  _deleteMediaBlock() {
    if (this.get('hasNoPreviousBlock')) {
      this.removeFirstSelectedBlock();
      if (this.get('nextBlock')) {
        this.setSelectionToStartOf(this.get('nextBlock'));
      } else {
        this.setSelectionToStartOf(this.insertDefaultBlock(0));
      }
      return CommandResult.create({
        shouldRerender: true
      });
    } else if (this.get('previousBlock.isMedia')) {
      this.removeFirstSelectedBlock();
      this.setSelectionToStartOf(this.get('previousBlock'));
      return CommandResult.create({
        shouldRerender: true
      });
    } else {
      return this._joinPreviousBlock();
    }
  },
  _joinPreviousBlock() {
    if (this._shouldInsertBr()) {
      return this._insertBrAndJoin();
    }
    this.setSelectionToEndOf(this.get('previousBlock'));
    let mutationResult = this.get('previousBlock').join(this.get('firstSelectedBlock'));
    this.removeBlocks(mutationResult.get('blocksToRemove'));
    return CommandResult.create({
      shouldRerender: true
    });
  },
  _insertBrAndJoin() {
    this.set('options', {
      character: Constants.NEW_LINE
    });
    this.applyActionToFirstSelectedBlock('insertCharacter');
    this.setSelectionToEndOf(this.get('previousBlock'));
    let mutationResult = this.get('previousBlock').join(this.get('firstSelectedBlock'));
    this.removeBlocks(mutationResult.get('blocksToRemove'));
    this.moveSelectionRightBy(1);
    this.collapseSelection();
    return CommandResult.create({
      shouldRerender: true
    });
  },
  _zeroWidthAtItemZero() {
    let selection;
    selection = this.get('firstSelectedBlockItemSelection');
    let splitResult = this.get('firstSelectedBlock').split(selection, true);
    this.insertBlock(splitResult, this.get('selection.startBlockIndex') + 1);
    let paragraph = this.insertDefaultBlock(this.get('selection.startBlockIndex') + 1);
    let mutationResult = paragraph.join(splitResult);
    this.removeBlocks(mutationResult.get('blocksToRemove'));
    if (this.get('firstSelectedBlock.isEmpty')) {
      this.removeFirstSelectedBlock();
    }
    this.setSelectionToStartOf(paragraph);
    return CommandResult.create({
      shouldRerender: true
    });
  },
  _undoListReplacement() {
    let trigger = this.get('firstSelectedBlock.trigger') || '';
    let triggerAlignment = this.get('firstSelectedBlock.triggerAlignment');
    let firstItemText = this.get('firstSelectedBlock.blockList').objectAt(0).get('text') || '';
    let firstItemEntities = this.get('firstSelectedBlock.blockList').objectAt(0).get('entities') || '';
    firstItemEntities.shiftRightBy(trigger.length);
    let paragraphText = trigger + firstItemText;
    this.removeFirstSelectedBlock();
    let paragraph = this.insertDefaultBlock(this.get('selection.startBlockIndex'));
    paragraph.setProperties({
      text: paragraphText,
      entities: firstItemEntities
    });
    if (trigger) {
      paragraph.addReplacementToSkip(trigger);
      this.setSelectionToPositionIndex(trigger.length);
    } else {
      this.setSelectionToStartOf(paragraph);
    }
    if (triggerAlignment) {
      paragraph.set('align', triggerAlignment);
    }
    return CommandResult.create({
      shouldRerender: true
    });
  },
  _singleListBlock() {
    let blockList = this.get('firstSelectedBlock.blockList');
    let selection = this.get('firstSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    this.constructor.create({
      blockList,
      selection,
      config: this.get('config')
    }).run();
    this.collapseSelection();
    return CommandResult.create();
  },
  _delegateToFirstSelectedBlock() {
    let blockList, selection;
    blockList = this.get('firstSelectedBlock.blockList');
    selection = this.get('firstSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    return this.constructor.create({
      blockList,
      selection,
      config: this.get('config')
    }).run();
  },
  _delegateToLastSelectedBlock() {
    let blockList, selection;
    blockList = this.get('lastSelectedBlock.blockList');
    selection = this.get('lastSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    return this.constructor.create({
      blockList,
      selection,
      config: this.get('config')
    }).run();
  },
  _joinLists() {
    this._delegateToFirstSelectedBlock('delete');
    this._delegateToLastSelectedBlock('delete');
    this.setSelectionToEndOf(this.get('firstSelectedBlock'));
    this._setItemSelections();
    if (!this.get('lastSelectedBlock.isEmpty')) {
      this.get('firstSelectedBlock').join(this.get('lastSelectedBlock'), {
        mergeItems: true
      });
    }
    this.removeBlock(this.get('lastSelectedBlock'));
    return CommandResult.create();
  },
  _shouldJoinLists() {
    return this.get('firstSelectedBlock.isListType') && this.get('lastSelectedBlock.isListType') && this.get('isFirstSelectedBlockNotCovered') && this.get('isLastSelectedBlockNotCovered');
  },
  _shouldInsertBr() {
    return !this.get('previousBlock.isListType') && !this.get('previousBlock.isHeadingType') && !(this.get('firstSelectedBlock.isHeadingType') && this.get('previousBlock.text') === '') && !this.get('firstSelectedBlock.isMedia') && this.get('previousBlock.type') !== 'listItem';
  }
});